import Vue from 'vue'
import Router from 'vue-router'
import selectTable from '@/page/selectTable'
import dataList from '@/page/dataList'
import correct from '@/page/correct'
import log from '../page/log'
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'selectTable',
    component: selectTable,
    // 保存路由数据
    meta: {keepAlive: true}
  },
  {
    path: '/dataList',
    name: 'dataList',
    component: dataList
  },
  {
    path: '/correct',
    name: 'correct',
    component: correct
  },
  {
    path: '/log',
    name: 'log',
    component: log
  }
]

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js